import { AxiosResponse } from 'axios';

import { Scheduler } from '../pages/inventory-control/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessGetScheduler extends ResponseREST {
	data: Array<Scheduler>;
}

export const getScheduler = async (): Promise<ResponseSuccessGetScheduler> => {
	return axiosInstance
		.get('get-list-scheduler')
		.then((res: AxiosResponse<ResponseSuccessGetScheduler>) => res.data)
		.catch((err) => err);
};
